import Eviction from './Eviction';

export default Eviction;
